import _isEqual from "lodash/isEqual";
import _cloneDeep from "lodash/cloneDeep";
import {SetProperties} from "@/models/SetProperties";

export class IdentityCardParent {
  constructor() {
    this.list = []
  }

  add(item) {
    this.list.push(IdentityCard.build(item))
  }

  update(item) {
    const index = this.list.findIndex(el => el.id === item.id)
    this.list.splice(index, 1, IdentityCard.build(item))
  }

  remove(item) {
    const index = this.list.findIndex(el => _isEqual(_cloneDeep(el), _cloneDeep(item)))
    index >=0 && this.list.splice(index, 1)
  }

  getForAPI() {
    return this.list.map(el => el.getForAPI())
  }

  build(obj) {
    if (obj) {
      this.list = obj.map(el => IdentityCard.build(el))
    }
    return this
  }
}

export class IdentityCard extends SetProperties{
  constructor() {
    super()
    this.id = null
    this.application = null
    this.series = null
    this.number = null
    this.issueDate = null
    this.issueBy = null
    this.identityCardDocType = null
    this.identityCardDocTypeName = null
    this.citizenship = null
    this.filesData = {}
  }

  getForAPI() {
    return {
      id: this.id,
      application: this.application,
      series: this.series,
      number: this.number,
      issueDate: this.issueDate,
      issueBy: this.issueBy,
      identityCardDocType: this.identityCardDocType,
      identityCardDocTypeName: this.identityCardDocTypeName,
      citizenship: this.citizenship,
    }
  }

  static build(obj) {
    const _this = new IdentityCard()
    if (obj) {
      _this.id = obj.id
      _this.application = obj.application
      _this.series = obj.series
      _this.number = obj.number
      _this.issueDate = obj.issueDate
      _this.issueBy = obj.issueBy
      _this.identityCardDocType = obj.identityCardDocType
      _this.identityCardDocTypeName = obj.identityCardDocTypeName
      _this.citizenship = obj.citizenship
    }
    return _this
  }
}
